<div class="card">

    <p-table #miSurvey [value]="pondConsolidatedTableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'AppId',
            'Farmer_Name',
            'Mobile',
            'District',
            'Block',
            'Village',
            'Applicant_type',
            'UserType',
            'Coverage_Area',
            'Total_Cost',
            'IntimationStatus_Stage1',
            'JeStatus_Stage1',
            'XENStatus_Stage1',
            'JE_EWStatus_Stage1',
            'DD_EWStatus_Stage1',
            'IntimationStatus_Stage2',
            'JeStatus_Stage2',
            'XENStatus_Stage2',
            'JE_EWStatus_Stage2',
            'DD_EWStatus_Stage2',
            'LotStatus_Stage1',
            'LotStatus_Stage2',
            'LotStatus_Stage3',
            'ReqFinYear',
            'KYCDate',
            'KYCStatus',          
            ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end" [ngStyle]="{'color': 'black'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ 'Pond Consolidated Detail' |
                        translate}}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-12 md:col-4 d-flex justify-content-center">
                    <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="miUnderProcessReport"></p-menu>

                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()"
                        [(ngModel)]="selectedMIUnderProcFilter" placeholder="{{'ALL'| translate}}"
                        optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="miUnderProcessReport"></p-menu> -->
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'APP_ID'| translate}}</th>
                <th>{{'FARMER_NAME'| translate}}</th>
                <th>{{'MOBILE_NO'| translate}}</th>
                <th>{{'DISTRICT'| translate}}</th>
                <th>{{'BLOCK'| translate}}</th>
                <th>{{'VILLAGE'| translate}}</th>
                <th>{{'Applicant Type'| translate}}</th>
                <th>{{'User Type'| translate}}</th>
                <th>{{'Coverage Area'| translate}}</th>
                <th>{{'Total Cost'| translate}}</th>
                <th>{{'Intimation Status Stage1'| translate}}</th>
                <th>{{'Je Status Stage1'| translate}}</th>
                <th>{{'XEN Status Stage1'| translate}}</th>
                <th>{{'JE EW Status Stage1'| translate}}</th>
                <th>{{'DD EW Status Stage1'| translate}}</th>
                <th>{{'IntimationStatus Stage2'| translate}}</th>
                <th>{{'JeStatus Stage2'| translate}}</th>
                <th>{{'XENStatus Stage2'| translate}}</th>
                <th>{{'JE EWStatus Stage2'| translate}}</th>
                <th>{{'DD EWStatus Stage2'| translate}}</th>
                <th>{{'Lot Status Stage1'| translate}}</th>
                <th>{{'Lot Status Stage2'| translate}}</th>
                <th>{{'Lot Status Stage3'| translate}}</th>
                <th>{{'FinYear'| translate}}</th>
                <th>{{'KYC Date'| translate}}</th>
                <th>{{'KYC Status'| translate}}</th>
                <!-- <th>{{'Total Iterations'| translate}}</th> -->
                
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
            <tr class="body-section">
                <td>{{consolidateData?.AppId}}</td>
                <td>{{consolidateData?.Farmer_Name}}</td>
                <td>{{consolidateData?.Mobile}}</td>
                <td>{{consolidateData?.District}}</td>
                <td>{{consolidateData?.Block}}</td>
                <td>{{consolidateData?.Village}}</td>
                <td>{{consolidateData?.Applicant_type}}</td>
                <td>{{consolidateData?.UserType}}</td>
                <td>{{consolidateData?.Coverage_Area}}</td>
                <td>{{consolidateData?.Total_Cost}}</td>               
                <td>{{consolidateData?.IntimationStatus_Stage1}}</td>
                <td>{{consolidateData?.JeStatus_Stage1}}</td>
                <td>{{consolidateData?.XENStatus_Stage1}}</td>
                <td>{{consolidateData?.JE_EWStatus_Stage1}}</td>
                <td>{{consolidateData?.DD_EWStatus_Stage1}}</td>
                <td>{{consolidateData?.IntimationStatus_Stage2}}</td>
                <td>{{consolidateData?.JeStatus_Stage2}}</td>
                <td>{{consolidateData?.XENStatus_Stage2}}</td>
                <td>{{consolidateData?.JE_EWStatus_Stage2}}</td>
                <td>{{consolidateData?.DD_EWStatus_Stage2}}</td>
                <td>{{consolidateData?.LotStatus_Stage1}}</td>
                <td>{{consolidateData?.LotStatus_Stage2}}</td>
                <td>{{consolidateData?.LotStatus_Stage3}}</td>
                <td>{{consolidateData?.ReqFinYear}}</td>
                <td>{{consolidateData?.KYCDate}}</td>
                <td>{{consolidateData?.KYCStatus}}</td>
                <!-- <td>{{consolidateData?.TotalIterations}}</td> -->
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">

        </ng-template>

    </p-table>

    <!-- <div class="mt-2" style="display: flex; justify-content: center;">
        <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary"
            (click)="onClickBack()"></button>
    </div> -->
</div>